module.exports = __webpack_public_path__ + "static/media/how-we-work2.28d16e1c.svg";